import React from 'react';

const SectionHeader = ({ eyebrow, title, accent, description, className = '' }) => {
  return (
    <div className={`mx-auto max-w-4xl space-y-4 text-center ${className}`}>
      <div className="inline-block">
        <span className="rounded-full bg-blue-100 px-4 py-2 text-sm font-semibold uppercase tracking-wider text-blue-600 dark:bg-blue-900/30 dark:text-cyan-400">
          {eyebrow}
        </span>
      </div>

      <h2 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white md:text-5xl lg:text-6xl">
        {title}
        {accent ? (
          <span className="block bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
            {accent}
          </span>
        ) : null}
      </h2>

      {description ? (
        <p className="mx-auto max-w-3xl text-lg leading-relaxed text-gray-600 dark:text-gray-400 md:text-xl">
          {description}
        </p>
      ) : null}
    </div>
  );
};

export default SectionHeader;
